import { gql } from "@apollo/client";

import * as fragment from "./fragments";

export const EXPORT_DONATIONS_REPORT_MUTATION = gql`
  mutation ExportDonationsReport($projectId: ID!) {
    exportDonationsReport(projectId: $projectId) {
      success
    }
  }
`;

export const EXPORT_EXCEL_DATA_MUTATION = gql`
  mutation ExportExcelData(
    $projectId: ID
    $clientId: ID
    $columnsOrder: String
    $assetIds: [ID!]
    $excludeReceivedAssets: Boolean
  ) {
    exportExcelData(
      projectId: $projectId
      clientId: $clientId
      columnsOrder: $columnsOrder
      assetIds: $assetIds
      excludeReceivedAssets: $excludeReceivedAssets
    ) {
      success
    }
  }
`;

export const EXPORT_ALT_EXCEL_DATA_MUTATION = gql`
  mutation ExportAltExcelData($projectId: ID!) {
    exportAltExcelData(projectId: $projectId) {
      success
    }
  }
`;

export const EXPORT_LIFE_SCIENCES_EXCEL_DATA_MUTATION = gql`
  mutation ExportLifeSciencesExcelData($projectId: ID, $clientId: ID) {
    exportLifeSciencesExcelData(projectId: $projectId, clientId: $clientId) {
      success
    }
  }
`;

export const EXPORT_GROUPED_ASSETS_EXCEL_MUTATION = gql`
  mutation ExportGroupedAssetsExcel($projectId: ID!) {
    exportGroupedAssetsExcel(projectId: $projectId) {
      success
    }
  }
`;

export const EXPORT_PROJECT_DELIVERY_ADDRESSES_EXCEL_MUTATION = gql`
  mutation ExportProjectDeliveryAddressesExcel($projectId: ID!) {
    exportProjectDeliveryAddressesExcel(projectId: $projectId) {
      success
    }
  }
`;

export const DELETE_BILLING_REPORT_MUTATION = gql`
  mutation DeleteBillingReport($billingReportId: ID!) {
    deleteBillingReport(billingReportId: $billingReportId) {
      success
      errors {
        field
        message
      }
    }
  }
`;

export const DOWNLOAD_ASSETS_IMAGES_MUTATION = gql`
  mutation DownloadAssetsImages($projectId: ID!, $assetIds: [ID!]) {
    downloadAssetsImages(projectId: $projectId, assetIds: $assetIds) {
      success
    }
  }
`;

export const CREATE_BARCODE_SCAN_MUTATION = gql`
  mutation CreateBarcode(
    $projectId: ID!,
    $clientId: ID!,
    $barcode: String!,
    $quantity: String!,
    $location: String!,
    $address: String!,
    $position: String!,
    $employeeName: String!
  ) {
    createBarcodeScan(
      projectId: $projectId,
      clientId: $clientId,
      barcode: $barcode,
      quantity: $quantity,
      location: $location,
      address: $address,
      position: $position,
      employeeName: $employeeName
    ) {
      barcodeScan {
        ${fragment.BARCODE_SCAN_FRAGMENT}
      }
    }
  }
`;
export const CREATE_IMAGE_MUTATION = gql`
  mutation CreateImage($assetId: ID!, $url: String!, $default: Boolean) {
    createImage(assetId: $assetId, url: $url, default: $default) {
      asset {
        ${fragment.ASSET_FRAGMENT}
      }
      image {
        ${fragment.ASSET_IMAGE_FRAGMENT}
      }
    }
  }
`;

export const GENERATE_PROJECT_REPORT_MUTATION = gql`
  mutation GenerateProjectReport($projectId: ID, $projectIds: [ID!], $clientId: ID, $favoriteReportId: ID!, $mode: String, $filters: JSON!, $receivingNotes: String) {
    generateProjectReport(projectId: $projectId, projectIds: $projectIds, clientId: $clientId, mode: $mode, favoriteReportId: $favoriteReportId, filters: $filters, receivingNotes: $receivingNotes) {
      project {
        ${fragment.PROJECT_FRAGMENT}
      }
    }
  }
`;

export const GENERATE_PROJECT_REPORT_BY_CLIENT_MUTATION = gql`
  mutation GenerateProjectReportByClient($clientId: ID!, $favoriteReportId: ID!, $mode: String, $filters: JSON!, $receivingNotes: String) {
    generateProjectReportByClient(clientId: $clientId, mode: $mode, favoriteReportId: $favoriteReportId, filters: $filters, receivingNotes: $receivingNotes) {
      client {
        ${fragment.CLIENT_FRAGMENT}
      }
    }
  }
`;

export const CREATE_FAVORITE_REPORT_MUTATION = gql`
  mutation CreateFavoriteReport($payload: JSON!) {
    createFavoriteReport(payload: $payload) {
      favoriteReport {
        ${fragment.FAVORITE_REPORTS_FRAGMENT}
      }
      favoriteReports {
        ${fragment.FAVORITE_REPORTS_FRAGMENT}
      }
    }
  }
`;
export const UPDATE_FAVORITE_REPORT_MUTATION = gql`
  mutation UpdateFavoriteReport($id: ID!, $payload: JSON!, $reportNotes: String, $projectIds: [ID!]) {
    updateFavoriteReport(id: $id, payload: $payload, reportNotes: $reportNotes, projectIds: $projectIds) {
      favoriteReport {
        ${fragment.FAVORITE_REPORTS_FRAGMENT}
      }
    }
  }
`;

// ######################################## NEW MUTATIONS #################################################

export const CREATE_PROJECT_MUTATION = gql`
  mutation CreateProject(
    $clientId: ID,
    $clientName: String,
    $projectName: String!,
    $addresses: [AddressInput!],
    $storageEnabled: Boolean,
    $onsiteCaptureToWarehouseStorage: Boolean,
    $escalationEmailSendList: String,
    $projectType: String,
    $externalRecordId: ID,
  ) {
    createProject(
      clientId: $clientId,
      clientName: $clientName,
      projectName: $projectName,
      addresses: $addresses,
      storageEnabled: $storageEnabled,
      onsiteCaptureToWarehouseStorage: $onsiteCaptureToWarehouseStorage,
      escalationEmailSendList: $escalationEmailSendList,
      projectType: $projectType,
      externalRecordId: $externalRecordId,
    ) {
      project {
        ${fragment.SIMPLE_PROJECT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const DUPLICATE_PROJECT_MUTATION = gql`
  mutation DuplicateProject(
    $sourceProjectId: ID!,
    $newProjectName: String!,
    $clientId: ID,
    $externalRecordId: ID
  ) {
    duplicateProject(
      sourceProjectId: $sourceProjectId,
      newProjectName: $newProjectName,
      clientId: $clientId,
      externalRecordId: $externalRecordId
    ) {
      project {
        ${fragment.SIMPLE_PROJECT_FRAGMENT}
      }
      client {
        ${fragment.CLIENT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_CLIENT_MUTATION = gql`
  mutation CreateClient($clientName: String!) {
    createClient(clientName: $clientName) {
      client {
        ${fragment.CLIENT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_PROJECT_MUTATION = gql`
  mutation UpdateProject(
    $id: ID!,
    $name: String,
    $disabled: Boolean,
    $addresses: [AddressInput!],
    $storageEnabled: Boolean,
    $projectType: String,
    $escalationEmailSendList: String,
    $customerName: String,
    $customerOwner: String,
    $customerNotes: String,
    $contactName: String,
    $contactEmail: String,
    $contactPhoneNumber: String,
    $customerEmailSendList: String,
    $osDEmailSendList: String,
    $billingEmailSendList: String,
    $outboundOnlyEmailSendList: String,
    $deliveryOnlyEmailSendList: String,
    $approvedEmailSendList: String,
    $automatedReportsEmailSendList: String,
    $billingMethod: String,
    $billingDate: String,
    $billingAnchorDate: String,
    $billingNotes: String,
    $importedAssets: Boolean,
    $settings: JSON,
    $partnerLogoUrl: Upload,
    $customerLogoUrl: Upload,
    $removePartnerLogoUrl: Boolean,
    $removeCustomerLogoUrl: Boolean,
    $referenceAssets: Boolean,
    $orderNumber: String,
    $addPreviouslyReceivedAssetsToShipments: Boolean,
    $customerPoNumber: String,
    $shipmentItemUnitBreakdown: Boolean,
    $mainLogoSelection: String,
    $kitting: Boolean,
    $groupedAssets: Boolean,
    $groupedSerializedAssets: Boolean,
    $billing: Boolean,
    $receivingWizardBillingStep: Boolean,
    $shipmentPdfFields: JSON,
    $shipmentItemPdfFields: JSON,
    $inventoryRequestPdf: JSON,
    $allowExternalUsersToCreateInternalOrders: Boolean,
    $allowExternalUsersToEditOrders: Boolean,
    $minimumAssetImages: Int,
    $minimumShipmentImages: Int,
    $shipmentItemPdfPreferences: JSON,
  ) {
    updateProject(
      id: $id,
      name: $name,
      disabled: $disabled,
      addresses: $addresses,
      storageEnabled: $storageEnabled,
      projectType: $projectType,
      escalationEmailSendList: $escalationEmailSendList,
      customerName: $customerName,
      customerOwner: $customerOwner,
      customerNotes: $customerNotes,
      contactName: $contactName,
      contactEmail: $contactEmail,
      contactPhoneNumber: $contactPhoneNumber,
      customerEmailSendList: $customerEmailSendList,
      osDEmailSendList: $osDEmailSendList,
      billingEmailSendList: $billingEmailSendList,
      outboundOnlyEmailSendList: $outboundOnlyEmailSendList,
      deliveryOnlyEmailSendList: $deliveryOnlyEmailSendList,
      approvedEmailSendList: $approvedEmailSendList,
      automatedReportsEmailSendList: $automatedReportsEmailSendList,
      billingMethod: $billingMethod,
      billingDate: $billingDate,
      billingAnchorDate: $billingAnchorDate,
      billingNotes: $billingNotes,
      importedAssets: $importedAssets,
      settings: $settings,
      partnerLogoUrl: $partnerLogoUrl,
      customerLogoUrl: $customerLogoUrl,
      removePartnerLogoUrl: $removePartnerLogoUrl,
      removeCustomerLogoUrl: $removeCustomerLogoUrl,
      referenceAssets: $referenceAssets,
      orderNumber: $orderNumber,
      addPreviouslyReceivedAssetsToShipments: $addPreviouslyReceivedAssetsToShipments,
      customerPoNumber: $customerPoNumber,
      shipmentItemUnitBreakdown: $shipmentItemUnitBreakdown,
      mainLogoSelection: $mainLogoSelection,
      kitting: $kitting,
      groupedAssets: $groupedAssets,
      groupedSerializedAssets: $groupedSerializedAssets,
      billing: $billing,
      receivingWizardBillingStep: $receivingWizardBillingStep,
      shipmentPdfFields: $shipmentPdfFields,
      shipmentItemPdfFields: $shipmentItemPdfFields,
      inventoryRequestPdf: $inventoryRequestPdf,
      allowExternalUsersToCreateInternalOrders: $allowExternalUsersToCreateInternalOrders,
      allowExternalUsersToEditOrders: $allowExternalUsersToEditOrders,
      minimumAssetImages: $minimumAssetImages,
      minimumShipmentImages: $minimumShipmentImages,
      shipmentItemPdfPreferences: $shipmentItemPdfPreferences,
    ) {
      project {
        ${fragment.PROJECT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const EMAIL_BILLING_REPORT_MUTATION = gql`
  mutation EmailBillingReport($billingReportId: ID!, $projectBillingEmailSendList: String) {
    emailBillingReport(
      billingReportId: $billingReportId
      projectBillingEmailSendList: $projectBillingEmailSendList
    ) {
      billingReport {
        id
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const SEND_REPLACEMENT_INVOICE_MUTATION = gql`
  mutation SendReplacementInvoice($billingReportId: ID!) {
    sendReplacementInvoice(billingReportId: $billingReportId) {
      invoice {
        id
        number
        status
        replacement
        exports {
          id
          provider
          status
          filename
          deliveredAt
        }
      }
      errors {
        field
        message
      }
    }
  }
`;

export const GENERATE_INVOICE_EXPORT_MUTATION = gql`
  mutation GenerateInvoiceExport($billingReportId: ID!) {
    generateInvoiceExport(billingReportId: $billingReportId) {
      invoice {
        id
        number
        status
        replacement
      }
      export {
        id
        filename
      }
      content
      errors {
        field
        message
      }
    }
  }
`;

export const EXPORT_BILLING_LINE_ITEMS_EXCEL_MUTATION = gql`
  mutation ExportBillingLineItemsExcel(
    $projectId: ID!
    $startDate: ISO8601Date
    $endDate: ISO8601Date
  ) {
    exportBillingLineItemsExcel(projectId: $projectId, startDate: $startDate, endDate: $endDate) {
      success
    }
  }
`;

export const UPDATE_CLIENT_MUTATION = gql`
  mutation UpdateClient(
    $id: ID!,
    $name: String!,
    $disabled: Boolean!,
    $clientEmailSendList: String,
    $clientBillingEmailSendList: String,
    $clientOsdEmailSendList: String,
    $mainLogoSelection: String,
    $shipmentItemPdfPreferences: JSON,
    $taxableChargeTypes: [String!],
    $storageCalculationMethod: String,
    $vendorName: String,
    $branchCode: String,
  ) {
    updateClient(
      id: $id,
      name: $name,
      disabled: $disabled,
      clientEmailSendList: $clientEmailSendList,
      clientBillingEmailSendList: $clientBillingEmailSendList,
      clientOsdEmailSendList: $clientOsdEmailSendList,
      mainLogoSelection: $mainLogoSelection,
      shipmentItemPdfPreferences: $shipmentItemPdfPreferences,
      taxableChargeTypes: $taxableChargeTypes,
      storageCalculationMethod: $storageCalculationMethod,
      vendorName: $vendorName,
      branchCode: $branchCode,
    ) {
      client {
        ${fragment.CLIENT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_WAREHOUSE_MUTATION = gql`
  mutation CreateWarehouse(
    $name: String!,
    $salesTaxRate: Float,
    $warehouseId: String,
    $addressAttributes: AddressInput,
  ) {
    warehouseCreate(
      name: $name,
      salesTaxRate: $salesTaxRate,
      warehouseId: $warehouseId,
      addressAttributes: $addressAttributes,
    ) {
      warehouse {
        id
        warehouseId
        name
        salesTaxRate
        createdAt
        updatedAt
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_WAREHOUSE_MUTATION = gql`
  mutation UpdateWarehouse(
    $id: ID!,
    $name: String,
    $warehouseEmailSendList: String,
    $salesTaxRate: Float,
    $addressAttributes: AddressInput,
    $excludeFromBilling: Boolean,
  ) {
    warehouseUpdate(
      id: $id,
      name: $name,
      warehouseEmailSendList: $warehouseEmailSendList,
      salesTaxRate: $salesTaxRate,
      addressAttributes: $addressAttributes,
      excludeFromBilling: $excludeFromBilling,
    ) {
      warehouse {
        id
        warehouseId
        name
        warehouseEmailSendList
        salesTaxRate
        excludeFromBilling
        createdAt
        updatedAt
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const GENERATE_WAREHOUSE_LOCATION_IMPORT_TEMPLATE_MUTATION = gql`
  mutation GenerateWarehouseLocationImportTemplate($locationKind: WarehouseLocationImportKindEnum!) {
    generateWarehouseLocationImportTemplate(locationKind: $locationKind) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const IMPORT_WAREHOUSE_LOCATIONS_MUTATION = gql`
  mutation ImportWarehouseLocations($warehouseId: ID!, $file: Upload!) {
    importWarehouseLocations(warehouseId: $warehouseId, file: $file) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const IMPORT_MOBILE_WAREHOUSE_LOCATIONS_MUTATION = gql`
  mutation ImportMobileWarehouseLocations($warehouseId: ID!, $file: Upload!) {
    importMobileWarehouseLocations(warehouseId: $warehouseId, file: $file) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_BARCODE_MUTATION = gql`
  mutation CreateBarcode($assetId: ID!, $code: String!) {
    createBarcode(assetId: $assetId, code: $code) {
      asset {
        ${fragment.ASSET_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_BARCODE_MUTATION = gql`
  mutation UpdateBarcode($barcodeId: ID!, $code: String!) {
    updateBarcode(barcodeId: $barcodeId, code: $code) {
      asset {
        ${fragment.ASSET_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const DELETE_BARCODE_MUTATION = gql`
  mutation DeleteBarcode($id: ID!) {
    deleteBarcode(id: $id) {
      asset {
        ${fragment.ASSET_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const REMOVE_ASSET_MUTATION = gql`
  mutation AssetRemove($id: ID!) {
    assetRemove(id: $id) {
      asset {
        ${fragment.ASSET_FRAGMENT}
        ${fragment.ASSET_MEDICAL_FRAGMENT}
      }
    }
  }
`;

export const REMOVE_KIT_MUTATION = gql`
  mutation DeleteKit($id: ID!) {
    deleteKit(id: $id) {
      kit {
        ${fragment.KIT_FRAGMENT}
      }
    }
  }
`;
export const REMOVE_KIT_ASSET_MUTATION = gql`
  mutation DeleteKitAsset($id: ID!) {
    deleteKitAsset(id: $id) {
      kitAsset {
        id
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const DELETE_IMAGE_MUTATION = gql`
  mutation RemoveAssetImage($id: ID!) {
    removeAssetImage(id: $id) {
      asset {
        id
        images {
          ${fragment.ASSET_IMAGE_FRAGMENT}
        }
        photo
      }
      image {
        ${fragment.ASSET_IMAGE_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ADD_ASSET_IMAGE_MUTATION = gql`
  mutation AddAssetImage($assetId: ID!, $image: Upload!, $default: Boolean) {
    addAssetImage(assetId: $assetId, image: $image, default: $default) {
      asset {
        id
        images {
          ${fragment.ASSET_IMAGE_FRAGMENT}
        }
        photo
      }
      image {
        ${fragment.ASSET_IMAGE_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const BULK_CREATE_ASSET_IMAGES_MUTATION = gql`
  mutation BulkCreateAssetImages($assetId: ID!, $images: [Upload!]!, $default: Boolean) {
    bulkCreateAssetImages(assetId: $assetId, images: $images, default: $default) {
      images {
        ${fragment.ASSET_IMAGE_FRAGMENT}
      }
      asset {
        id
        photo
        images {
          ${fragment.ASSET_IMAGE_FRAGMENT}
        }
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const BULK_REMOVE_ASSET_IMAGES_MUTATION = gql`
  mutation BulkRemoveAssetImages($assetIds: [ID!]!) {
    bulkRemoveAssetImages(assetIds: $assetIds) {
      successCount
      failedAssetIds
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const BULK_CREATE_WAREHOUSE_LOCATION_IMAGES_MUTATION = gql`
  mutation WarehouseLocationBulkCreateImages($warehouseLocationId: ID!, $warehouseLocationImages: [Upload!]!) {
    warehouseLocationBulkCreateImages(warehouseLocationId: $warehouseLocationId, warehouseLocationImages: $warehouseLocationImages) {
      warehouseLocation {
        id
        warehouseLocationImages {
          ${fragment.WAREHOUSE_LOCATION_IMAGE_FRAGMENT}
        }
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_WAREHOUSE_LOCATION_IMAGE_MUTATION = gql`
  mutation WarehouseLocationUpdateImage($id: ID!, $url: String!, $default: Boolean) {
    warehouseLocationUpdateImage(id: $id, url: $url, default: $default) {
      warehouseLocation {
        id
        warehouseLocationImages {
          ${fragment.WAREHOUSE_LOCATION_IMAGE_FRAGMENT}
        }
      }
      warehouseLocationImage {
        ${fragment.WAREHOUSE_LOCATION_IMAGE_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const DELETE_WAREHOUSE_LOCATION_IMAGE_MUTATION = gql`
  mutation WarehouseLocationRemoveImage($id: ID!) {
    warehouseLocationRemoveImage(id: $id) {
      warehouseLocation {
        id
        warehouseLocationImages {
          ${fragment.WAREHOUSE_LOCATION_IMAGE_FRAGMENT}
        }
      }
      warehouseLocationImage {
        ${fragment.WAREHOUSE_LOCATION_IMAGE_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_IMAGE_MUTATION = gql`
  mutation AssetUpdateImage($id: ID!, $url: String!, $default: Boolean) {
    assetUpdateImage(id: $id, url: $url, default: $default) {
      asset {
        id
        images {
          ${fragment.ASSET_IMAGE_FRAGMENT}
        }
        photo
      }
      image {
        ${fragment.ASSET_IMAGE_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_COMPANY_SUBSCRIPTION_MUTATION = gql`
  mutation CreateCompanySubscription($companyId: ID!, $companyPlanId: ID!) {
    createCompanySubscription(companyId: $companyId, companyPlanId: $companyPlanId) {
      companySubscription {
        id
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CANCEL_COMPANY_SUBSCRIPTION_MUTATION = gql`
  mutation CancelCompanySubscription($companyId: ID!) {
    cancelCompanySubscription(companyId: $companyId) {
      companySubscription {
        id
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const SIGN_IN_USER_MUTATION = gql`
  mutation SignInUser($email: String!, $password: String!, $remember: Boolean, $companyId: ID) {
    signInUser(email: $email, password: $password, remember: $remember, companyId: $companyId) {
      user {
        ${fragment.USER_FRAGMENT}
        companyUrl
      }
      workspaces {
        id
        name
        subdomain
        vendorName
        labelsLogoUrl
        isAdministrate
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const SWITCH_WORKSPACE_MUTATION = gql`
  mutation SwitchWorkspace($companyId: ID!) {
    switchWorkspace(companyId: $companyId) {
      user {
        token
        company {
          id
          subdomain
          isAdministrate
        }
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const INVITE_USER_MUTATION = gql`
  mutation InviteUser(
    $userId: ID
    $email: String
    $clientIds: [String!]
    $projectIds: [String!]
    $costCenterIds: [String!]
    $role: String
    $assignmentScope: UserAssignmentScopeInput
  ) {
    inviteUser(
      userId: $userId
      email: $email
      clientIds: $clientIds
      projectIds: $projectIds
      costCenterIds: $costCenterIds
      role: $role
      assignmentScope: $assignmentScope
    ) {
      user {
        ${fragment.USER_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_USER_PASSWORD_MUTATION = gql`
  mutation UpdateUserPassword($password: String!, $passwordConfirmation: String!, $oldPassword: String!) {
    updateUserPassword(password: $password, passwordConfirmation: $passwordConfirmation, oldPassword: $oldPassword) {
      user {
        ${fragment.USER_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_USER_PROFILE_MUTATION = gql`
  mutation UpdateUserProfile($email: String!, $name: String!, $phoneNumber: String!, $settings: JSON) {
    updateUserProfile(email: $email, name: $name, phoneNumber: $phoneNumber, settings: $settings) {
      user {
        ${fragment.USER_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser(
    $captureTableSettings: JSON
    $assetsTableSettings: JSON
    $trackingTableSettings: JSON
    $kitsTableSettings: JSON
    $warehouseTableSettings: JSON
  ) {
    updateUser(
      captureTableSettings: $captureTableSettings
      assetsTableSettings: $assetsTableSettings
      trackingTableSettings: $trackingTableSettings
      kitsTableSettings: $kitsTableSettings
      warehouseTableSettings: $warehouseTableSettings
    ) {
      user {
        ${fragment.USER_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_USER_ACCOUNT_MUTATION = gql`
  mutation UpdateUserAccount(
    $id: ID!
    $removeClientIds: [ID!]
    $addClientIds: [ID!]
    $clientIds: [ID!]
    $projectIds: [ID!]
    $costCenterIds: [ID!]
    $assignmentScope: UserAssignmentScopeInput
    $role: String
    $name: String
    $settings: JSON
    $active: Boolean
    ) {
    updateUserAccount(
      id: $id
      removeClientIds: $removeClientIds
      addClientIds: $addClientIds
      clientIds: $clientIds
      projectIds: $projectIds
      costCenterIds: $costCenterIds
      assignmentScope: $assignmentScope
      role: $role
      name: $name
      settings: $settings
      active: $active
      ) {
      user {
        ${fragment.USER_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_SELECTION_CONTEXT_MUTATION = gql`
  mutation UpdateSelectionContext($clientId: String, $projectId: String, $warehouseId: String) {
    updateSelectionContext(clientId: $clientId, projectId: $projectId, warehouseId: $warehouseId) {
      user {
        ${fragment.USER_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const MARK_LATEST_RELEASE_SEEN_MUTATION = gql`
  mutation MarkLatestReleaseSeen {
    markLatestReleaseSeen {
      user {
        ${fragment.USER_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_COMPANY_PERMISSIONS_MUTATION = gql`
  mutation UpdateCompanyPermissions($permissions: JSON!) {
    updateCompanyPermissions(permissions: $permissions) {
      company {
        permissions
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ACCEPT_INVITATION_MUTATION = gql`
  mutation AcceptInvitation($password: String!, $passwordConfirmation: String!, $accessToken: String!, $name: String!) {
    acceptInvitation(password: $password, passwordConfirmation: $passwordConfirmation, accessToken: $accessToken, name: $name) {
      user {
        ${fragment.USER_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const GENERATE_INVITATION_LINK_MUTATION = gql`
  mutation GenerateInvitationLink($userId: ID!) {
    generateInvitationLink(userId: $userId) {
      invitationUrl
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const GENERATE_PASSWORD_RESET_LINK_MUTATION = gql`
  mutation GeneratePasswordResetLink($userId: ID!) {
    generatePasswordResetLink(userId: $userId) {
      resetPasswordUrl
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ADD_SHOPPING_INVENTORY_ITEM_MUTATION = gql`
  mutation AddShoppingInventoryItem($assetId: ID!, $quantity: Int!, $deliveryDate: String, $deliveryTime: String, $building: String, $floor: String, $room: String, $location: String, $comment: String, $street: String, $city: String, $zip: String, $poNumber: String, $idsrNumber: String, $eocNumber: String, $contactName: String, $contactPhoneNumber: String) {
    addShoppingInventoryItem(assetId: $assetId, quantity: $quantity, deliveryDate: $deliveryDate, deliveryTime: $deliveryTime, building: $building, floor: $floor, room: $room, location: $location, comment: $comment, street: $street, city: $city, zip: $zip, poNumber: $poNumber, idsrNumber: $idsrNumber, eocNumber: $eocNumber, contactName: $contactName, contactPhoneNumber: $contactPhoneNumber) {
     inventoryItem {
        ${fragment.SHOPPING_INVENTORY_ITEM_FRAGMENT}
      }
      asset {
        ${fragment.SIMPLE_ASSET_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const MOVE_INVENTORY_ITEMS_MUTATION = gql`
  mutation MoveInventoryItems($input: MoveInventoryItemsInput!) {
    moveInventoryItems(input: $input) {
      sourceInventoryRequest {
        id
        inventoryItems {
          id
          quantity
        }
      }
      destinationInventoryRequest {
        id
        inventoryItems {
          id
          quantity
        }
      }
      movedInventoryItems {
        id
        quantity
        asset {
          ${fragment.SIMPLE_ASSET_FRAGMENT}
        }
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_KIT_ASSET_MUTATION = gql`
  mutation CreateKitAsset($kitId: ID!, $input: KitAssetInput!) {
    createKitAsset(kitId: $kitId, input: $input) {
      kit {
        ${fragment.KIT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_KIT_ASSET_MUTATION = gql`
  mutation UpdateKitAsset($id: ID!, $input: KitAssetInput!) {
    updateKitAsset(id: $id, input: $input) {
      kitAsset {
        id
        quantity
        asset {
          ${fragment.ASSET_FRAGMENT}
        }
      }
      kit {
        ${fragment.ASSET_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_GROUPED_ASSET_MEMBER_MUTATION = gql`
  mutation CreateGroupedAssetMember($groupedAssetId: ID!, $input: GroupedAssetMemberInput!) {
    createGroupedAssetMember(groupedAssetId: $groupedAssetId, input: $input) {
      groupedAsset {
        ${fragment.ASSET_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const DELETE_GROUPED_ASSET_MEMBER_MUTATION = gql`
  mutation DeleteGroupedAssetMember($id: ID!) {
    deleteGroupedAssetMember(id: $id) {
      success
      groupedAssetMember {
        id
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_SHOPPING_INVENTORY_ITEM_MUTATION = gql`
  mutation UpdateShoppingInventoryRequestItem($inventoryItemId: ID!, $quantity: Int!, $deliveryDate: String, $deliveryTime: String, $building: String, $floor: String, $room: String, $location: String, $comment: String, $street: String, $city: String, $zip: String, $poNumber: String, $idsrNumber: String, $eocNumber: String) {
    updateShoppingInventoryRequestItem(inventoryItemId: $inventoryItemId, quantity: $quantity, deliveryDate: $deliveryDate, deliveryTime: $deliveryTime, building: $building, floor: $floor, room: $room, location: $location, comment: $comment, street: $street, city: $city, zip: $zip, poNumber: $poNumber, idsrNumber: $idsrNumber, eocNumber: $eocNumber) {
      inventoryItem {
        ${fragment.SHOPPING_INVENTORY_ITEM_FRAGMENT}
      }
      asset {
        ${fragment.SIMPLE_ASSET_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const MAKE_SHOPPING_INVENTORY_REQUEST_MUTATION = gql`
  mutation MakeShoppingInventoryRequest($input: ShoppingInventoryRequest!, $inventoryRequestId: ID) {
    makeShoppingInventoryRequest(input: $input, inventoryRequestId: $inventoryRequestId) {
      inventoryRequest {
        id
        workOrderNumber
        ${fragment.SHOPPING_INVENTORY_REQUEST_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const MAKE_SHOPPING_INVENTORY_REQUEST_ASYNC_MUTATION = gql`
  mutation MakeShoppingInventoryRequestAsync($input: ShoppingInventoryRequest!, $inventoryRequestId: ID) {
    makeShoppingInventoryRequestAsync(input: $input, inventoryRequestId: $inventoryRequestId) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const COMBINE_SHOPPING_INVENTORY_REQUESTS_MUTATION = gql`
  mutation CombineShoppingInventoryRequests($inventoryRequestIds: [ID!]!) {
    combineShoppingInventoryRequests(inventoryRequestIds: $inventoryRequestIds) {
      inventoryRequest {
        ${fragment.SIMPLE_SHOPPING_INVENTORY_REQUEST_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const RESOLVE_INVENTORY_ITEM_MUTATION = gql`
  mutation ResolveInventoryItem($assetId: ID!, $inventoryRequestId: ID!, $status: String!) {
    resolveInventoryItem(assetId: $assetId, inventoryRequestId: $inventoryRequestId, status: $status) {
      inventoryRequest {
        id
        status
        reviewStatus
      }
      inventoryItem {
        id
        status
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CHECK_OUT_INVENTORY_ITEM_MUTATION = gql`
  mutation CheckOutInventoryItem($inventoryRequestId: ID!, $code: String!, $quantity: Int!) {
    checkOutInventoryItem(inventoryRequestId: $inventoryRequestId, code: $code, quantity: $quantity) {
      inventoryRequest {
        id
        reviewStatus
      }
      inventoryItem {
        id
        status
        quantity
        checkedOutQuantity
        checkedInQuantity
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CHECK_IN_INVENTORY_ITEM_MUTATION = gql`
  mutation CheckInInventoryItem($inventoryRequestId: ID!, $code: String!, $quantity: Int!) {
    checkInInventoryItem(inventoryRequestId: $inventoryRequestId, code: $code, quantity: $quantity) {
      inventoryRequest {
        id
        reviewStatus
      }
      inventoryItem {
        id
        status
        quantity
        checkedOutQuantity
        checkedInQuantity
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CHECK_OUT_MUTATION = gql`
  mutation CheckOut($code: String!) {
    checkOut(code: $code) {
      amount
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CHECK_IN_MUTATION = gql`
  mutation CheckIn($code: String!) {
    checkIn(code: $code) {
      amount
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ADD_PROJECT_ADDRESS_MUTATION = gql`
  mutation AddProjectAddress(
    $projectId: ID!
    $addressName: String
    $street: String
    $street2: String
    $city: String
    $state: String
    $zipCode: String
  ) {
    addProjectAddress(
      projectId: $projectId
      addressName: $addressName
      street: $street
      street2: $street2
      city: $city
      state: $state
      zipCode: $zipCode
    ) {
      project {
        ${fragment.PROJECT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_PROJECT_SETTINGS_MUTATION = gql`
  mutation UpdateProjectSettings(
    $projectId: ID!
    $fieldSettings: JSON
    $receivingSettings: JSON
    $billingRates: JSON
    $laborRates: JSON
    $materialRates: JSON
    $openInspectRates: JSON
    $equipmentRates: JSON
    $billingTypes: JSON
    $shipmentPdfFields: JSON
    $shipmentItemPdfFields: JSON
    $inventoryRequestPdf: JSON
    $shipmentItemMoveLabelPdfFields: JSON
    $storeCardFields: JSON
    $taxableChargeTypes: [String!]
    $storageCalculationMethod: String
    $monthlyValuationFee: Float
    $billingQuantityCalculationMode: JSON
    $billingRules: JSON
    $colocationBillingEnabled: Boolean
    $useMinimumChargeForStorage: Boolean
  ) {
    updateProjectSettings(
      projectId: $projectId
      fieldSettings: $fieldSettings
      receivingSettings: $receivingSettings
      billingRates: $billingRates
      laborRates: $laborRates
      materialRates: $materialRates
      openInspectRates: $openInspectRates
      equipmentRates: $equipmentRates
      billingTypes: $billingTypes
      shipmentPdfFields: $shipmentPdfFields
      shipmentItemPdfFields: $shipmentItemPdfFields
      inventoryRequestPdf: $inventoryRequestPdf
      shipmentItemMoveLabelPdfFields: $shipmentItemMoveLabelPdfFields
      storeCardFields: $storeCardFields
      taxableChargeTypes: $taxableChargeTypes
      storageCalculationMethod: $storageCalculationMethod
      monthlyValuationFee: $monthlyValuationFee
      billingQuantityCalculationMode: $billingQuantityCalculationMode
      billingRules: $billingRules
      colocationBillingEnabled: $colocationBillingEnabled
      useMinimumChargeForStorage: $useMinimumChargeForStorage
    ) {
      project {
        id
        name
        disabled
        active
        fieldSettings
        receivingSettings
        billingRates
        laborRates
        materialRates
        openInspectRates
        equipmentRates
        billingTypes
        shipmentPdfFields
        shipmentItemPdfFields
        inventoryRequestPdf
        shipmentItemMoveLabelPdfFields
        storeCardFields
        taxableChargeTypes
        resolvedTaxableChargeTypes
        storageCalculationMethod
        resolvedStorageCalculationMethod
        monthlyValuationFee
        billingQuantityCalculationMode
        billingRules
        colocationBillingEnabled
        useMinimumChargeForStorage
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CALCULATE_ALL_BILLING_MUTATION = gql`
  mutation CalculateAllBilling(
    $projectId: ID!
    $repairInvalidShipmentBillingTypes: Boolean
    $syncStorageAssetBillingTypes: Boolean
  ) {
    calculateAllBilling(
      projectId: $projectId
      repairInvalidShipmentBillingTypes: $repairInvalidShipmentBillingTypes
      syncStorageAssetBillingTypes: $syncStorageAssetBillingTypes
    ) {
      success
      errors
    }
  }
`;

export const UPDATE_COMPANY_SETTINGS_MUTATION = gql`
  mutation UpdateCompanyDefaultSettings(
    $fieldSettings: JSON
    $receivingSettings: JSON
    $billingRates: JSON
    $laborRates: JSON
    $materialRates: JSON
    $openInspectRates: JSON
    $equipmentRates: JSON
    $shipmentPdfFields: JSON
    $shipmentItemPdfFields: JSON
    $inventoryRequestPdf: JSON
    $projectTypeFieldSettings: JSON
    $billingImportTemplateLayout: String
    $companySettings: JSON
  ) {
    updateCompanyDefaultSettings(
      fieldSettings: $fieldSettings
      receivingSettings: $receivingSettings
      billingRates: $billingRates
      laborRates: $laborRates
      materialRates: $materialRates
      openInspectRates: $openInspectRates
      equipmentRates: $equipmentRates
      shipmentPdfFields: $shipmentPdfFields
      shipmentItemPdfFields: $shipmentItemPdfFields
      inventoryRequestPdf: $inventoryRequestPdf
      projectTypeFieldSettings: $projectTypeFieldSettings
      billingImportTemplateLayout: $billingImportTemplateLayout
      companySettings: $companySettings
    ) {
      company {
        settings
        fieldSettings
        receivingSettings
        billingRates
        laborRates
        materialRates
        openInspectRates
        equipmentRates
        shipmentPdfFields
        shipmentItemPdfFields
        inventoryRequestPdf
        projectTypeFieldSettings
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_INTERNAL_WORK_ORDER_TYPES_MUTATION = gql`
  mutation UpdateInternalWorkOrderTypes($internalWorkOrderTypes: JSON!) {
    updateInternalWorkOrderTypes(internalWorkOrderTypes: $internalWorkOrderTypes) {
      company {
        id
        internalWorkOrderTypes
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const GENERATE_BILLING_TEMPLATE_MUTATION = gql`
  mutation GenerateBillingTemplate {
    generateBillingTemplate {
      reportLink
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const EXPORT_USERS_MUTATION = gql`
  mutation ExportUsers {
    exportUsers {
      success
    }
  }
`;

export const IMPORT_BILLING_SETTINGS_MUTATION = gql`
  mutation ImportBillingSettings($file: Upload!) {
    importBillingSettings(file: $file) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const IMPORT_ASSETS_MUTATION = gql`
  mutation ImportAssets($file: Upload!, $projectId: ID!, $assetType: String) {
    importAssets(file: $file, projectId: $projectId, assetType: $assetType) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const IMPORT_PROCUREMENT_SHEET_MUTATION = gql`
  mutation ImportProcurementSheet($file: Upload!, $projectId: ID!) {
    importProcurementSheet(file: $file, projectId: $projectId) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_MOVE_MATRIX_MUTATION = gql`
  mutation CreateMoveMatrix($file: Upload!, $projectId: ID) {
    createMoveMatrix(file: $file, projectId: $projectId) {
      moveMatrices {
        ${fragment.MOVE_MATRIX_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const RESET_USER_PASSWORD_MUTATION = gql`
  mutation ResetUserPassword($password: String!, $passwordConfirmation: String!, $resetPasswordToken: String!) {
    resetUserPassword(password: $password, passwordConfirmation: $passwordConfirmation, resetPasswordToken: $resetPasswordToken) {
      user {
        ${fragment.USER_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const FORGET_PASSWORD_REQUEST_MUTATION = gql`
  mutation ForgetPasswordRequest($email: String!) {
    forgetPasswordRequest(email: $email) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const REMOVE_CLIENT_MUTATION = gql`
  mutation RemoveClient($id: ID!) {
    removeClient(id: $id) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const EXCLUDE_USER_MUTATION = gql`
  mutation ExcludeUser($userId: ID!, $clientIds: [ID!]!) {
    excludeUser(userId: $userId, clientIds: $clientIds) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const REMOVE_PROJECT_MUTATION = gql`
  mutation RemoveProject($id: ID!) {
    removeProject(id: $id) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const TRANSFER_PROJECT_MUTATION = gql`
  mutation TransferProject($projectId: ID!, $targetClientId: ID!) {
    transferProject(projectId: $projectId, targetClientId: $targetClientId) {
      project {
        id
        name
        client {
          id
          name
        }
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const REMOVE_USER_MUTATION = gql`
  mutation RemoveUser($id: ID!) {
    removeUser(id: $id) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ASSETS_BULK_UPDATE_MUTATION = gql`
  mutation AssetsBulkUpdate($input: [AssetInput!]!) {
    assetsBulkUpdate(input: $input) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ASSETS_FIND_AND_REPLACE_MUTATION = gql`
  mutation AssetsFindAndReplace(
    $assetIds: [ID!]!
    $fieldName: String!
    $findText: String!
    $replaceText: String!
    $replaceFieldName: String
  ) {
    assetsFindAndReplace(
      assetIds: $assetIds
      fieldName: $fieldName
      findText: $findText
      replaceText: $replaceText
      replaceFieldName: $replaceFieldName
    ) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ASSETS_BULK_REMOVE_MUTATION = gql`
  mutation AssetsBulkRemove($ids: [ID!]!) {
    assetsBulkRemove(ids: $ids) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ADD_ASSET_ATTACHMENT_MUTATION = gql`
  mutation AssetAddAttachment($file: Upload!, $assetId: ID!) {
    assetAddAttachment(file: $file, assetId: $assetId) {
      attachment {
        ${fragment.ATTACHMENT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const REMOVE_ASSET_ATTACHMENT_MUTATION = gql`
  mutation RemoveAssetAttachment($id: ID!, $assetId: ID!) {
    assetRemoveAttachment(id: $id, assetId: $assetId) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_ATTACHMENT_SHIPMENTS = gql`
  mutation updateAttachmentShipments($id: ID!, $url: String!) {
    updateAttachmentShipments(id: $id, url: $url) {
      attachment {
        ${fragment.ATTACHMENT_FRAGMENT}
      }
    }
  }
`;

export const CREATE_ASSET_MUTATION = gql`
  mutation CreateAsset($projectId: ID!, $input: AssetInput!, $sourceAssetId: ID, $skipNotifications: Boolean, $skipRefreshCache: Boolean) {
    createAsset(projectId: $projectId, input: $input, sourceAssetId: $sourceAssetId, skipNotifications: $skipNotifications, skipRefreshCache: $skipRefreshCache) {
      asset {
        ${fragment.ASSET_FRAGMENT}
        ${fragment.ASSET_MEDICAL_FRAGMENT}
        nextAssetId
        prevAssetId
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_SKU_MUTATION = gql`
  mutation CreateSku($projectId: ID!, $input: AssetInput!) {
    createSku(projectId: $projectId, input: $input) {
      asset {
        ${fragment.ASSET_FRAGMENT}
        ${fragment.ASSET_MEDICAL_FRAGMENT}
        nextAssetId
        prevAssetId
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_KIT_MUTATION = gql`
  mutation CreateKit($projectId: ID!, $input: KitInput!) {
    createKit(projectId: $projectId, input: $input) {
      kit {
        ${fragment.ASSET_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_KIT_VARIANT_MUTATION = gql`
  mutation CreateKitVariant($kitId: ID!) {
    createKitVariant(kitId: $kitId) {
      kitVariant {
        ${fragment.ASSET_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_GROUPED_ASSET_MUTATION = gql`
  mutation CreateGroupedAsset($projectId: ID!, $input: GroupedAssetInput!) {
    createGroupedAsset(projectId: $projectId, input: $input) {
      groupedAsset {
        ${fragment.ASSET_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const TRANSFER_ASSET_MUTATION = gql`
  mutation AssetTransfer($projectId: ID!, $assetId: ID!) {
    assetTransfer(projectId: $projectId, assetId: $assetId) {
      asset {
        ${fragment.ASSET_FRAGMENT}
        ${fragment.ASSET_MEDICAL_FRAGMENT}
        nextAssetId
        prevAssetId
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_ASSET_MUTATION = gql`
  mutation UpdateAsset(
    $id: ID!
    $input: AssetInput!
    $expectedVersion: Int
    $baseValues: JSON
    $propagateToMatchingAssets: Boolean
    $previousSkuNumber: String
    $previousDescription: String
  ) {
    updateAsset(
      id: $id
      input: $input
      expectedVersion: $expectedVersion
      baseValues: $baseValues
      propagateToMatchingAssets: $propagateToMatchingAssets
      previousSkuNumber: $previousSkuNumber
      previousDescription: $previousDescription
    ) {
      asset {
        ${fragment.ASSET_FRAGMENT}
        ${fragment.ASSET_MEDICAL_FRAGMENT}
        nextAssetId
        prevAssetId
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
      conflict
      propagatedAssetsCount
    }
  }
`;

export const RECALCULATE_ASSET_AVAILABLE_QUANTITY_MUTATION = gql`
  mutation RecalculateAssetAvailableQuantity($assetId: ID!) {
    recalculateAssetAvailableQuantity(assetId: $assetId) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_INVENTORY_TRANSACTION_MUTATION = gql`
  mutation CreateInventoryTransaction($code: String!, $quantity: Int!, $notes: String!, $senderName: String!, $carrierName: String!, $trackingNumber: String!, $orderNumber: String!, $poNumber: String!, $rackLocations: JSON!, $rackLocationsChanges: JSON!, $shipmentItemId: ID, $inventoryItemId: ID, $internalWorkOrderItemId: ID, $oldRackLocations: JSON, $assetId: ID, $actionSource: String, $skipRefreshCache: Boolean, $skipLocationUpdates: Boolean) {
    createInventoryTransaction(code: $code, quantity: $quantity, notes: $notes, senderName: $senderName, carrierName: $carrierName, trackingNumber: $trackingNumber, orderNumber: $orderNumber, poNumber: $poNumber, rackLocations: $rackLocations, rackLocationsChanges: $rackLocationsChanges, shipmentItemId: $shipmentItemId, inventoryItemId: $inventoryItemId, internalWorkOrderItemId: $internalWorkOrderItemId, oldRackLocations: $oldRackLocations, assetId: $assetId, actionSource: $actionSource, skipRefreshCache: $skipRefreshCache, skipLocationUpdates: $skipLocationUpdates) {
      asset {
        ${fragment.ASSET_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ACCEPT_GUEST_MUTATION = gql`
  mutation AcceptGuest($token: String!) {
    acceptGuest(token: $token) {
      user {
        id
        token
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_ACCESS_LINK_MUTATION = gql`
  mutation CreateAccessLink(
    $projectIds: [String!]
    $permissions: JSON
    $active: Boolean
    $name: String
    ) {
    createAccessLink(
      projectIds: $projectIds
      permissions: $permissions
      active: $active
      name: $name
    ) {
      accessLink {
        ${fragment.ACCESS_LINK_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_PROJECT_ACCESS_LINK_MUTATION = gql`
  mutation CreateProjectAccessLink($projectId: ID!) {
    createProjectAccessLink(projectId: $projectId) {
      accessLink {
        ${fragment.ACCESS_LINK_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_ACCESS_LINK_MUTATION = gql`
  mutation UpdateAccessLink(
    $id: ID!
    $projectIds: [String!]
    $permissions: JSON
    $active: Boolean
    $name: String
  ) {
    updateAccessLink(
      id: $id
      projectIds: $projectIds
      permissions: $permissions
      active: $active
      name: $name
    ) {
      accessLink {
        ${fragment.ACCESS_LINK_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const REMOVE_ACCESS_LINK_MUTATION = gql`
  mutation RemoveAccessLink($id: ID!) {
    removeAccessLink(id: $id) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ADD_INVENTORY_REQUEST_ATTACHMENT_MUTATION = gql`
  mutation InventoryRequestAddAttachment($file: Upload!, $inventoryRequestId: ID!) {
    inventoryRequestAddAttachment(file: $file, inventoryRequestId: $inventoryRequestId) {
      attachment {
        ${fragment.ATTACHMENT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const REMOVE_INVENTORY_REQUEST_ATTACHMENT_MUTATION = gql`
  mutation InventoryRequestRemoveAttachment($inventoryRequestId: ID!, $id: ID!) {
    inventoryRequestRemoveAttachment(inventoryRequestId: $inventoryRequestId, id: $id) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ADD_INVENTORY_REQUEST_FINAL_RELEASE_ATTACHMENT_MUTATION = gql`
  mutation InventoryRequestAddFinalReleaseAttachment($file: Upload!, $inventoryRequestId: ID!) {
    inventoryRequestAddFinalReleaseAttachment(file: $file, inventoryRequestId: $inventoryRequestId) {
      attachment {
        ${fragment.ATTACHMENT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const REMOVE_INVENTORY_REQUEST_FINAL_RELEASE_ATTACHMENT_MUTATION = gql`
  mutation InventoryRequestRemoveFinalReleaseAttachment($inventoryRequestId: ID!, $id: ID!) {
    inventoryRequestRemoveFinalReleaseAttachment(inventoryRequestId: $inventoryRequestId, id: $id) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ADD_INTERNAL_WORK_ORDER_ATTACHMENT_MUTATION = gql`
  mutation InternalWorkOrderAddAttachment($file: Upload!, $internalWorkOrderId: ID!) {
    internalWorkOrderAddAttachment(file: $file, internalWorkOrderId: $internalWorkOrderId) {
      attachment {
        ${fragment.ATTACHMENT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const REMOVE_INTERNAL_WORK_ORDER_ATTACHMENT_MUTATION = gql`
  mutation InternalWorkOrderRemoveAttachment($internalWorkOrderId: ID!, $id: ID!) {
    internalWorkOrderRemoveAttachment(internalWorkOrderId: $internalWorkOrderId, id: $id) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const PROJECT_BULK_CREATE_IMAGES_MUTATION = gql`
  mutation ProjectBulkCreateImages($projectId: ID!, $projectImages: [Upload!]!) {
    projectBulkCreateImages(projectId: $projectId, projectImages: $projectImages) {
      projectImages {
        ${fragment.ATTACHMENT_FRAGMENT}
      }
      project {
        id
        images {
          ${fragment.ATTACHMENT_FRAGMENT}
        }
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const PROJECT_REMOVE_IMAGE_MUTATION = gql`
  mutation ProjectRemoveImage($id: ID!) {
    projectRemoveImage(id: $id) {
      project {
        id
        images {
          ${fragment.ATTACHMENT_FRAGMENT}
        }
      }
      projectImage {
        ${fragment.ATTACHMENT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ADD_ATTACHMENT_INTERNAL_WORK_ORDER_ITEMS = gql`
  mutation AddAttachmentInternalWorkOrderItems($file: Upload!, $internalWorkOrderItemId: ID!, $pairId: Int) {
    addAttachmentInternalWorkOrderItems(file: $file, internalWorkOrderItemId: $internalWorkOrderItemId, pairId: $pairId) {
      attachment {
        ${fragment.ATTACHMENT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const REMOVE_ATTACHMENT_INTERNAL_WORK_ORDER_ITEMS = gql`
  mutation RemoveAttachmentInternalWorkOrderItems($id: ID!, $internalWorkOrderItemId: ID!) {
    removeAttachmentInternalWorkOrderItems(
      id: $id
      internalWorkOrderItemId: $internalWorkOrderItemId
    ) {
      success
    }
  }
`;

export const UPDATE_ATTACHMENT_INTERNAL_WORK_ORDER_ITEMS = gql`
  mutation updateAttachmentInternalWorkOrderItems($id: ID!, $url: String!) {
    updateAttachmentInternalWorkOrderItems(id: $id, url: $url) {
      attachment {
        ${fragment.ATTACHMENT_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_INVENTORY_REQUEST_MUTATION = gql`
  mutation UpdateInventoryRequest($id: ID!, $input: UpdateInventoryRequestInput!) {
    updateInventoryRequest(id: $id, input: $input) {
      inventoryRequest {
        ${fragment.OPTIMIZED_INVENTORY_REQUEST_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const DELETE_INVENTORY_REQUEST_MUTATION = gql`
  mutation DeleteInventoryRequest($id: ID!) {
    deleteInventoryRequest(id: $id) {
      success
      status
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const DELETE_INVENTORY_ITEM_MUTATION = gql`
  mutation DeleteInventoryItem($id: ID!, $rackLocations: JSON) {
    deleteInventoryItem(id: $id, rackLocations: $rackLocations) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const DELETE_INVENTORY_ITEMS_MUTATION = gql`
  mutation DeleteInventoryItems($ids: [ID!]!) {
    deleteInventoryItems(ids: $ids) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const REORDER_INVENTORY_ITEMS_MUTATION = gql`
  mutation ReorderInventoryItems($id: ID!, $position: Int!) {
    reorderInventoryItems(id: $id, position: $position) {
      inventoryItems {
        ${fragment.INVENTORY_ITEM_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_INVENTORY_ITEM_MUTATION = gql`
  mutation UpdateInventoryItem($assetId: ID!, $id: ID!, $quantity: Int!, $deliveryDate: String, $deliveryTime: String, $building: String, $floor: String, $room: String, $location: String, $comment: String, $street: String, $city: String, $zip: String, $poNumber: String, $idsrNumber: String, $eocNumber: String, $disposition: String, $pickedStatus: Boolean, $stagedStatus: Boolean) {
    updateInventoryItem(assetId: $assetId, id: $id, quantity: $quantity, deliveryDate: $deliveryDate, deliveryTime: $deliveryTime, building: $building, floor: $floor, room: $room, location: $location, comment: $comment, street: $street, city: $city, zip: $zip, poNumber: $poNumber, idsrNumber: $idsrNumber, eocNumber: $eocNumber, disposition: $disposition, pickedStatus: $pickedStatus, stagedStatus: $stagedStatus) {
      inventoryItem {
        ${fragment.SHOPPING_INVENTORY_ITEM_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ADD_INVENTORY_ITEM_MUTATION = gql`
  mutation AddInventoryItem($assetId: ID!, $inventoryRequestId: ID!, $quantity: Int!, $location: String, $building: String, $city: String, $poNumber: String, $room: String, $street: String, $zip: String, $deliveryDate: String, $deliveryTime: String, $floor: String, $comment: String, $disposition: String, $idsrNumber: String, $eocNumber: String, $position: Int, $pickedStatus: Boolean, $rackLocationChanges: JSON, $stagedStatus: Boolean, $previousItemId: ID) {
    addInventoryItem(assetId: $assetId, inventoryRequestId: $inventoryRequestId, quantity: $quantity, location: $location, building: $building, city: $city, poNumber: $poNumber, room: $room, street: $street, zip: $zip, deliveryDate: $deliveryDate, deliveryTime: $deliveryTime, floor: $floor, comment: $comment, disposition: $disposition, idsrNumber: $idsrNumber, eocNumber: $eocNumber, position: $position, pickedStatus: $pickedStatus, rackLocationChanges: $rackLocationChanges, stagedStatus: $stagedStatus, previousItemId: $previousItemId) {
      inventoryItem {
        ${fragment.INVENTORY_ITEM_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_INBOUND_RESERVATION_MUTATION = gql`
  mutation CreateInboundReservation($projectId: ID!, $comment: String) {
    createInboundReservation(projectId: $projectId, comment: $comment) {
      inventoryRequest {
        ${fragment.SIMPLE_INVENTORY_REQUEST_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const REMOVE_LOCATION_MUTATION = gql`
  mutation DeleteLocation($id: ID!) {
    deleteLocation(id: $id) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const REMOVE_REQUESTOR_MUTATION = gql`
  mutation DeleteRequestor($id: ID!) {
    deleteRequestor(id: $id) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_LOCATION_MUTATION = gql`
  mutation CreateLocation($name: String!, $address: String!) {
    createLocation(name: $name, address: $address) {
      location {
        ${fragment.LOCATION_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_LOCATION_MUTATION = gql`
  mutation UpdateLocation($id: ID!, $name: String!, $address: String!, $favoriteLocation: Boolean, $priority: Int) {
    updateLocation(id: $id, name: $name, address: $address, favoriteLocation: $favoriteLocation, priority: $priority) {
      location {
        ${fragment.LOCATION_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_REQUESTOR_MUTATION = gql`
  mutation CreateRequestor($name: String!, $email: String!) {
    createRequestor(name: $name, email: $email) {
      requestor {
        ${fragment.REQUESTOR_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const DELETE_FAVORITE_REPORT = gql`
  mutation DeleteFavoriteReport($id: ID!) {
    deleteFavoriteReport(id: $id) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_PLAN = gql`
  mutation EquipmentPlannerCreateFloorPlan(
    $metadata: JSON!
    $projectId: ID!
    $state: JSON!
    $name: String!
  ) {
    equipmentPlannerCreateFloorPlan(
      metadata: $metadata
      projectId: $projectId
      state: $state
      name: $name
    ) {
      floorPlan {
        id
        name
      }
    }
  }
`;

export const DELETE_PLAN = gql`
  mutation EquipmentPlannerDeleteFloorPlan($floorPlanId: ID!) {
    equipmentPlannerDeleteFloorPlan(floorPlanId: $floorPlanId) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_PLAN = gql`
  mutation EquipmentPlannerUpdateFloorPlan($metadata: JSON!, $floorPlanId: ID!, $state: JSON!) {
    equipmentPlannerUpdateFloorPlan(metadata: $metadata, floorPlanId: $floorPlanId, state: $state) {
      floorPlan {
        id
        state
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ADD_ICONS = gql`
  mutation EquipmentPlannerAddIconSet($floorPlanId: ID!, $state: JSON!) {
    equipmentPlannerAddIconSet(floorPlanId: $floorPlanId, state: $state) {
      iconSet {
        id
        state
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_VIEW = gql`
  mutation EquipmentPlannerCreatePlanView($floorPlanId: ID!) {
    equipmentPlannerCreatePlanView(floorPlanId: $floorPlanId) {
      planView {
        id
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_PLANNER_VIEW = gql`
  mutation EquipmentPlannerUpgradePlanView($planViewId: ID!, $name: String!) {
    equipmentPlannerUpgradePlanView(planViewId: $planViewId, name: $name) {
      planView {
        id
        name
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_INTERNAL_WORK_ORDER_MUTATION = gql`
  mutation CreateInternalWorkOrder($input: InternalWorkOrderInput!) {
    createInternalWorkOrder(input: $input) {
      internalWorkOrder {
        ${fragment.OPTIMIZED_INTERNAL_WORK_ORDER_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const MAKE_INTERNAL_WORK_ORDER_FROM_CART_MUTATION = gql`
  mutation MakeInternalWorkOrderFromCart($input: InternalWorkOrderInput!, $inventoryRequestId: ID) {
    makeInternalWorkOrderFromCart(input: $input, inventoryRequestId: $inventoryRequestId) {
      internalWorkOrder {
        ${fragment.OPTIMIZED_INTERNAL_WORK_ORDER_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_INTERNAL_WORK_ORDER_MUTATION = gql`
  mutation UpdateInternalWorkOrder($id: ID!, $input: UpdateInternalWorkOrderInput!) {
    updateInternalWorkOrder(id: $id, input: $input) {
      internalWorkOrder {
        ${fragment.OPTIMIZED_INTERNAL_WORK_ORDER_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const DELETE_INTERNAL_WORK_ORDER_MUTATION = gql`
  mutation DeleteInternalWorkOrder($id: ID!) {
    deleteInternalWorkOrder(id: $id) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_INTERNAL_WORK_ORDER_ITEM_MUTATION = gql`
  mutation UpdateInternalWorkOrderItem($id: ID!, $input: InternalWorkOrderItemInput!) {
    updateInternalWorkOrderItem(id: $id, input: $input) {
      internalWorkOrderItem {
        id
        quantity
        nonAllocating
        comment
        completedStatus
        pickedStatus
        asset {
          id
          availableQuantity
        }
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const DELETE_INTERNAL_WORK_ORDER_ITEM_MUTATION = gql`
  mutation DeleteInternalWorkOrderItem($id: ID!) {
    deleteInternalWorkOrderItem(id: $id) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ADD_INTERNAL_WORK_ORDER_ITEM_MUTATION = gql`
  mutation AddInternalWorkOrderItem($internalWorkOrderId: ID!, $input: InternalWorkOrderItemInput!) {
    addInternalWorkOrderItem(internalWorkOrderId: $internalWorkOrderId, input: $input) {
      internalWorkOrderItem {
        id
        quantity
        nonAllocating
        comment
        createdAt
        completedStatus
        pickedStatus
        rackLocations
        asset {
          id
          assetId
          itemId
          model
          description
          barcode
          condition
          manufacturer
          model
          color
          dimensions
          skuNumber
          availableQuantity
          project {
            id
            name
          }
          images {
            url
            id
            default
          }
        }
        requestedBy {
          id
          name
          email
        }
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_PLANNER_FLOOR_PLAN = gql`
  mutation EquipmentPlannerUpgradeFloorPlan($floorPlanId: ID!, $name: String!) {
    equipmentPlannerUpgradeFloorPlan(floorPlanId: $floorPlanId, name: $name) {
      floorPlan {
        id
        name
        metadata
      }
    }
  }
`;

export const DELETE_PLANNER_VIEW = gql`
  mutation EquipmentPlannerDeletePlanView($planViewId: ID!) {
    equipmentPlannerDeletePlanView(planViewId: $planViewId) {
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_SHIPMENT_MUTATION = gql`
  mutation CreateShipment($input: ShipmentInput!) {
    createShipment(input: $input) {
      shipment {
        ${fragment.SHIPMENT_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_SHIPMENT_MUTATION = gql`
  mutation UpdateShipment($id: ID!, $input: ShipmentInput!) {
    updateShipment(id: $id, input: $input) {
      shipment {
        ${fragment.SHIPMENT_FRAGMENT}
      }
      errors {
        message
      }
    }
  }
`;

export const UPDATE_SHIPMENT_RECEIVED_AT_MUTATION = gql`
  mutation UpdateShipmentReceivedAt($id: ID!, $input: ShipmentInput!) {
    updateShipment(id: $id, input: $input) {
      errors {
        message
      }
    }
  }
`;

export const ADD_SHIPMENT_ITEMS_MUTATION = gql`
  mutation AddShipmentItems(
    $assetId: ID!
    $shipmentId: ID!
    $quantity: Int!
    $rackLocations: JSON
  ) {
    addShipmentItems(
      assetId: $assetId
      shipmentId: $shipmentId
      quantity: $quantity
      rackLocations: $rackLocations
    ) {
      shipmentItem {
        assetId
        quantity
        shipmentId
        id
      }
    }
  }
`;

export const DELETE_SHIPMENT_ITEMS_MUTATION = gql`
  mutation DeleteShipmentItems($id: ID!) {
    deleteShipmentItems(id: $id) {
      success
    }
  }
`;

export const UPDATE_SHIPMENT_ITEMS_MUTATION = gql`
  mutation UpdateShipmentItems($id: ID!, $quantity: Int!, $weight: Float, $rackLocations: JSON, $dimensions: JSON, $expectedQuantity: Int, $palletType: String, $palletsReceivedCount: String, $itemNotes: String, $totalPieces: JSON) {
    updateShipmentItems(id: $id, quantity: $quantity, weight: $weight, rackLocations: $rackLocations, dimensions: $dimensions, expectedQuantity: $expectedQuantity, palletType: $palletType, palletsReceivedCount: $palletsReceivedCount, itemNotes: $itemNotes, totalPieces: $totalPieces) {
      shipmentItem {
        ${fragment.SHIPMENT_ITEM_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const DELETE_SHIPMENT_MUTATION = gql`
  mutation DeleteShipment($id: ID!, $deleteCorrespondingAssets: Boolean) {
    deleteShipment(id: $id, deleteCorrespondingAssets: $deleteCorrespondingAssets) {
      success
    }
  }
`;

export const ADD_SHIPMENT_ATTACHMENT_MUTATION = gql`
  mutation AddAttachmentShipment($file: Upload!, $shipmentId: ID!) {
    addAttachmentShipment(file: $file, shipmentId: $shipmentId) {
      attachment {
        ${fragment.ATTACHMENT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const REMOVE_SHIPMENT_ATTACHMENT_MUTATION = gql`
  mutation RemoveAttachmentShipment($id: ID!, $shipmentId: ID!) {
    removeAttachmentShipment(id: $id, shipmentId: $shipmentId) {
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_ATTACHMENT_SHIPMENT_ITEMS = gql`
  mutation updateAttachmentShipmentItems($id: ID!, $url: String!) {
    updateAttachmentShipmentItems(id: $id, url: $url) {
      attachment {
        ${fragment.ATTACHMENT_FRAGMENT}
      }
    }
  }
`;

export const ADD_OVERAGES_SHORTAGES_DAMAGE = gql`
  mutation AddOveragesShortagesDamage(
    $shipmentItemId: ID!
    $osdType: String!
    $osdNotes: String
    $osdQuantity: Int
  ) {
    addOveragesShortagesDamage(
      shipmentItemId: $shipmentItemId
      osdType: $osdType
      osdNotes: $osdNotes
      osdQuantity: $osdQuantity
    ) {
      overagesShortagesDamage {
        id
        osdType
        osdNotes
        osdQuantity
        shipmentItem {
          id
          shipmentId
        }
      }
    }
  }
`;
export const UPDATE_OVERAGES_SHORTAGES_DAMAGE = gql`
  mutation UpdateOveragesShortagesDamage(
    $id: ID!
    $osdType: String!
    $osdNotes: String!
    $osdQuantity: Int!
  ) {
    updateOveragesShortagesDamage(
      id: $id
      osdType: $osdType
      osdNotes: $osdNotes
      osdQuantity: $osdQuantity
    ) {
      overagesShortagesDamage {
        id
        osdType
        osdNotes
        osdQuantity
        shipmentItem {
          id
          shipmentId
        }
      }
    }
  }
`;

export const DELETE_OVERAGES_SHORTAGES_DAMAGE = gql`
  mutation DeleteOveragesShortagesDamage($id: ID!) {
    deleteOveragesShortagesDamage(id: $id) {
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ADD_ATTACHMENT_OVERAGES_SHORTAGES_DAMAGE = gql`
  mutation AddAttachmentOveragesShortagesDamage($file: Upload!, $overagesShortagesDamageId: ID!) {
    addAttachmentOveragesShortagesDamage(file: $file, overagesShortagesDamageId: $overagesShortagesDamageId) {
      attachment {
        ${fragment.ATTACHMENT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const REMOVE_ATTACHMENT_OVERAGES_SHORTAGES_DAMAGE = gql`
  mutation RemoveAttachmentOveragesShortagesDamage($id: ID!, $overagesShortagesDamageId: ID!) {
    removeAttachmentOveragesShortagesDamage(id: $id, overagesShortagesDamageId: $overagesShortagesDamageId) {
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_ATTACHMENT_OVERAGES_SHORTAGES_DAMAGE = gql`
  mutation updateAttachmentOveragesShortagesDamage($id: ID!, $url: String!) {
    updateAttachmentOveragesShortagesDamage(id: $id, url: $url) {
      attachment {
        ${fragment.ATTACHMENT_FRAGMENT}
      }
    }
  }
`;

export const TRANSFER_SHIPMENT_MUTATION = gql`
  mutation TransferShipment($projectId: ID!, $shipmentId: ID!) {
    transferShipment(projectId: $projectId, shipmentId: $shipmentId) {
      shipment {
        ${fragment.SHIPMENT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const PARTIAL_TRANSFER_SHIPMENT_MUTATION = gql`
  mutation PartialTransferShipment($projectId: ID!, $shipmentId: ID!, $shipmentItemIds: [ID!]!) {
    partialTransferShipment(projectId: $projectId, shipmentId: $shipmentId, shipmentItemIds: $shipmentItemIds) {
      originalShipment {
        ${fragment.SHIPMENT_FRAGMENT}
      }
      newShipment {
        ${fragment.SHIPMENT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const NOTIFY_CUSTOMER_SHIPMENT_MUTATION = gql`
  mutation NotifyCustomerShipment($shipmentId: ID!) {
    notifyCustomerShipment(shipmentId: $shipmentId) {
      shipment {
        ${fragment.SHIPMENT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const WAREHOUSES_BULK_ASSIGN_CLIENTS = gql`
  mutation WarehousesBulkAssignClients($clientsWarehouses: JSON) {
    warehousesBulkAssignClients(clientsWarehouses: $clientsWarehouses) {
      warehouses {
        id
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const WAREHOUSES_BULK_UNASSIGN_CLIENTS = gql`
  mutation WarehousesBulkUnassignClients($clientsWarehouses: JSON) {
    warehousesBulkUnassignClients(clientsWarehouses: $clientsWarehouses) {
      warehouses {
        id
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ADD_ATTACHMENT_SHIPMENT_ITEMS = gql`
  mutation AddAttachmentShipmentItems($file: Upload, $url: String, $shipmentItemId: ID!, $pairId: Int) {
    addAttachmentShipmentItems(file: $file, url: $url, shipmentItemId: $shipmentItemId, pairId: $pairId) {
      attachment {
        ${fragment.ATTACHMENT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const REMOVE_ATTACHMENT_SHIPMENT_ITEMS = gql`
  mutation RemoveAttachmentShipmentItems($id: ID!, $shipmentItemId: ID!) {
    removeAttachmentShipmentItems(id: $id, shipmentItemId: $shipmentItemId) {
      success
    }
  }
`;

export const BULK_CREATE_MOBILE_LOCATION_IMAGES_MUTATION = gql`
  mutation MobileWarehouseLocationBulkCreateImages($warehouseLocationId: ID!, $attachments: [Upload!]!) {
    mobileWarehouseLocationBulkCreateImages(warehouseLocationId: $warehouseLocationId, attachments: $attachments) {
      mobileWarehouseLocation {
        id
        mobileLocationImage {
          ${fragment.WAREHOUSE_LOCATION_IMAGE_FRAGMENT}
        }
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_MOBILE_LOCATION_IMAGE_MUTATION = gql`
  mutation MobileWarehouseLocationUpdateImage($id: ID!, $url: String!, $default: Boolean) {
    mobileWarehouseLocationUpdateImage(id: $id, url: $url, default: $default) {
      mobileWarehouseLocation {
        id
        mobileLocationImage {
          ${fragment.WAREHOUSE_LOCATION_IMAGE_FRAGMENT}
        }
      }
      attachment {
        ${fragment.WAREHOUSE_LOCATION_IMAGE_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const DELETE_MOBILE_LOCATION_IMAGE_MUTATION = gql`
  mutation MobileWarehouseLocationRemoveImage($id: ID!) {
    mobileWarehouseLocationRemoveImage(id: $id) {
      mobileWarehouseLocation {
        id
        mobileLocationImage {
          ${fragment.WAREHOUSE_LOCATION_IMAGE_FRAGMENT}
        }
      }
      attachment {
        ${fragment.WAREHOUSE_LOCATION_IMAGE_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_BLACKOUT_DATES_MUTATION = gql`
  mutation UpdateBlackoutDates($blackoutDates: JSON!) {
    updateBlackoutDates(blackoutDates: $blackoutDates) {
      company {
        id
        blackoutDates
      }
      errors {
        field
        message
      }
    }
  }
`;

export const CREATE_COST_CENTER_MUTATION = gql`
  mutation CreateCostCenter(
    $projectId: ID!
    $costCenterName: String
    $costCenterCode: String
    $comments: String
    $useProjectBillingConfiguration: Boolean
    $minimumAssetImages: Int
    $generalNotificationsEmailSendList: String
    $osdEmailSendList: String
    $approvedEmailSendList: String
    $outboundOnlyEmailSendList: String
    $automatedReportsEmailSendList: String
  ) {
    createCostCenter(
      projectId: $projectId
      costCenterName: $costCenterName
      costCenterCode: $costCenterCode
      comments: $comments
      useProjectBillingConfiguration: $useProjectBillingConfiguration
      minimumAssetImages: $minimumAssetImages
      generalNotificationsEmailSendList: $generalNotificationsEmailSendList
      osdEmailSendList: $osdEmailSendList
      approvedEmailSendList: $approvedEmailSendList
      outboundOnlyEmailSendList: $outboundOnlyEmailSendList
      automatedReportsEmailSendList: $automatedReportsEmailSendList
    ) {
      costCenter {
        ${fragment.COST_CENTER_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_COST_CENTER_MUTATION = gql`
  mutation UpdateCostCenter(
    $id: ID!
    $costCenterName: String
    $costCenterCode: String
    $disabled: Boolean
    $comments: String
    $billingRates: JSON
    $laborRates: JSON
    $materialRates: JSON
    $openInspectRates: JSON
    $equipmentRates: JSON
    $billingTypes: JSON
    $useProjectBillingConfiguration: Boolean
    $minimumAssetImages: Int
    $generalNotificationsEmailSendList: String
    $osdEmailSendList: String
    $approvedEmailSendList: String
    $outboundOnlyEmailSendList: String
    $automatedReportsEmailSendList: String
  ) {
    updateCostCenter(
      id: $id
      costCenterName: $costCenterName
      costCenterCode: $costCenterCode
      disabled: $disabled
      comments: $comments
      billingRates: $billingRates
      laborRates: $laborRates
      materialRates: $materialRates
      openInspectRates: $openInspectRates
      equipmentRates: $equipmentRates
      billingTypes: $billingTypes
      useProjectBillingConfiguration: $useProjectBillingConfiguration
      minimumAssetImages: $minimumAssetImages
      generalNotificationsEmailSendList: $generalNotificationsEmailSendList
      osdEmailSendList: $osdEmailSendList
      approvedEmailSendList: $approvedEmailSendList
      outboundOnlyEmailSendList: $outboundOnlyEmailSendList
      automatedReportsEmailSendList: $automatedReportsEmailSendList
    ) {
      costCenter {
        ${fragment.COST_CENTER_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const DELETE_COST_CENTER_MUTATION = gql`
  mutation DeleteCostCenter($id: ID!) {
    deleteCostCenter(id: $id) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const WAREHOUSE_LOCATION_CREATE = gql`
  mutation WarehouseLocationCreate(
    $warehouseId: ID!
    $locationName: String!
    $searchTerms: String
    $slotGroupKey: String
    $locationType: String!
    $shelf: String!
    $slot: String!
    $sqFtOfSlot: Int!
    $zone: String!
    $aisle: String!
    $rack: String!
    $dimensions: JSON
  ) {
    warehouseLocationCreate(
      warehouseId: $warehouseId
      locationName: $locationName
      searchTerms: $searchTerms
      slotGroupKey: $slotGroupKey
      locationType: $locationType
      shelf: $shelf
      slot: $slot
      sqFtOfSlot: $sqFtOfSlot
      zone: $zone
      aisle: $aisle
      rack: $rack
      dimensions: $dimensions
    ) {
      warehouseLocation {
        locationId
        locationName
        slotGroupKey
        id
      }
      warehouseLocations {
        locationId
        locationName
        slotGroupKey
        id
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const WAREHOUSE_LOCATION_ADD_MISSING_CENTERS = gql`
  mutation WarehouseLocationAddMissingCenters($warehouseId: ID!, $leftLocationIds: [ID!]!) {
    warehouseLocationAddMissingCenters(
      warehouseId: $warehouseId
      leftLocationIds: $leftLocationIds
    ) {
      warehouseLocations {
        id
        locationId
        locationName
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const WAREHOUSE_LOCATIONS_BULK_CREATE = gql`
  mutation WarehouseLocationsBulkCreate(
    $warehouseId: ID!
    $locationNames: [String!]!
    $locationType: String!
    $slot: String!
    $sqFtOfSlot: Int!
    $zone: String!
    $aisle: String!
    $rack: String!
    $shelf: String!
    $searchTerms: String
    $slotGroupKey: String
    $dimensions: JSON
  ) {
    warehouseLocationsBulkCreate(
      warehouseId: $warehouseId
      locationNames: $locationNames
      locationType: $locationType
      slot: $slot
      sqFtOfSlot: $sqFtOfSlot
      zone: $zone
      aisle: $aisle
      rack: $rack
      shelf: $shelf
      searchTerms: $searchTerms
      slotGroupKey: $slotGroupKey
      dimensions: $dimensions
    ) {
      warehouseLocations {
        id
        locationId
        locationName
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const MOBILE_WAREHOUSE_LOCATION_CREATE = gql`
  mutation MobileWarehouseLocationCreate(
    $warehouseId: ID!
    $locationType: String!
    $locationName: String!
    $searchTerms: String
    $sqFtOfSlot: Int!
    $dimensions: JSON
  ) {
    mobileWarehouseLocationCreate(
      warehouseId: $warehouseId
      locationType: $locationType
      locationName: $locationName
      searchTerms: $searchTerms
      sqFtOfSlot: $sqFtOfSlot
      dimensions: $dimensions
    ) {
      mobileWarehouseLocation {
        id
        locationName
        locationId
        locationType
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const MOBILE_WAREHOUSE_LOCATIONS_BULK_CREATE = gql`
  mutation MobileWarehouseLocationBulkCreate(
    $warehouseId: ID!
    $locationNames: [String!]!
    $locationType: String!
    $searchTerms: String
    $sqFtOfSlot: Int!
    $zone: String
    $dimensions: JSON
  ) {
    mobileWarehouseLocationBulkCreate(
      warehouseId: $warehouseId
      locationNames: $locationNames
      locationType: $locationType
      searchTerms: $searchTerms
      sqFtOfSlot: $sqFtOfSlot
      zone: $zone
      dimensions: $dimensions
    ) {
      mobileWarehouseLocations {
        id
        locationName
        locationId
        locationType
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const START_WAREHOUSE_LOCATION_AUDIT_MUTATION = gql`
  mutation StartWarehouseLocationAudit($warehouseLocationId: ID, $mobileWarehouseLocationId: ID) {
    startWarehouseLocationAudit(
      warehouseLocationId: $warehouseLocationId
      mobileWarehouseLocationId: $mobileWarehouseLocationId
    ) {
      audit {
        id
        status
        startedAt
        preAuditSnapshot
      }
      errors {
        field
        message
      }
    }
  }
`;

export const COMPLETE_WAREHOUSE_LOCATION_AUDIT_MUTATION = gql`
  mutation CompleteWarehouseLocationAudit($auditId: ID!, $notes: String) {
    completeWarehouseLocationAudit(auditId: $auditId, notes: $notes) {
      audit {
        id
        status
        startedAt
        completedAt
        durationSeconds
        notes
        postAuditSnapshot
        auditItems {
          id
          asset {
            id
            assetId
            itemId
          }
          status
          preAuditQuantity
          postAuditQuantity
        }
      }
      errors {
        field
        message
      }
    }
  }
`;

export const WAREHOUSE_LOCATION_UPDATE = gql`
  mutation WarehouseLocationUpdate(
    $id: ID!
    $locationName: String!
    $searchTerms: String
    $slotGroupKey: String
    $locationType: String!
    $shelf: String!
    $slot: String!
    $sqFtOfSlot: Int!
    $zone: String!
    $aisle: String!
    $rack: String!
    $dimensions: JSON
    $active: Boolean
  ) {
    warehouseLocationUpdate(
      id: $id
      locationName: $locationName
      searchTerms: $searchTerms
      slotGroupKey: $slotGroupKey
      locationType: $locationType
      shelf: $shelf
      slot: $slot
      sqFtOfSlot: $sqFtOfSlot
      zone: $zone
      aisle: $aisle
      rack: $rack
      dimensions: $dimensions
      active: $active
    ) {
      warehouseLocation {
        id
        locationId
        locationName
        searchTerms
        slotGroupKey
        locationType
        sqFtOfSlot
        zone
        aisle
        rack
        shelf
        slot
        dimensions
        active
      }
      errors {
        field
        message
      }
    }
  }
`;

export const WAREHOUSE_LOCATIONS_BULK_UPDATE_ACTIVE = gql`
  mutation WarehouseLocationsBulkUpdateActive(
    $warehouseLocationIds: [ID!]!
    $mobileWarehouseLocationIds: [ID!]!
    $active: Boolean!
  ) {
    warehouseLocationsBulkUpdateActive(
      warehouseLocationIds: $warehouseLocationIds
      mobileWarehouseLocationIds: $mobileWarehouseLocationIds
      active: $active
    ) {
      successCount
      errors {
        field
        message
      }
    }
  }
`;

export const WAREHOUSE_LOCATIONS_EXPORT_EXCEL = gql`
  mutation WarehouseLocationsExportExcel(
    $warehouseLocationIds: [ID!]!
    $mobileWarehouseLocationIds: [ID!]!
  ) {
    warehouseLocationsExportExcel(
      warehouseLocationIds: $warehouseLocationIds
      mobileWarehouseLocationIds: $mobileWarehouseLocationIds
    ) {
      success
      errors {
        field
        message
      }
    }
  }
`;

export const MOBILE_WAREHOUSE_LOCATION_UPDATE = gql`
  mutation MobileWarehouseLocationUpdate(
    $id: ID!
    $locationType: String!
    $locationName: String!
    $searchTerms: String
    $sqFtOfSlot: Int!
    $zone: String
    $dimensions: JSON
    $active: Boolean
  ) {
    mobileWarehouseLocationUpdate(
      id: $id
      locationType: $locationType
      locationName: $locationName
      searchTerms: $searchTerms
      sqFtOfSlot: $sqFtOfSlot
      zone: $zone
      dimensions: $dimensions
      active: $active
    ) {
      mobileWarehouseLocation {
        id
        locationId
        locationName
        searchTerms
        locationType
        sqFtOfSlot
        zone
        dimensions
        active
      }
      errors {
        field
        message
      }
    }
  }
`;

export const REMOVE_ASSET_IN_CART_QUANTITY_MUTATION = gql`
  mutation RemoveAssetInCartQuantity($assetId: ID!, $userId: ID) {
    removeAssetInCartQuantity(assetId: $assetId, userId: $userId) {
      asset {
        id
        ${fragment.ASSET_FRAGMENT}
      }
      users {
        id
        email
      }
    }
  }
`;

export const RELEASE_PROJECT_SHOPPING_CART_MUTATION = gql`
  mutation ReleaseProjectShoppingCart($projectId: ID!, $userId: ID!) {
    releaseProjectShoppingCart(projectId: $projectId, userId: $userId) {
      success
      releasedItemCount
      user {
        id
      }
      errors {
        field
        message
      }
    }
  }
`;

export const CUSTOM_FIELD_TEMPLATE_CREATE = gql`
  mutation CustomFieldTemplateCreate($defaultLabel: String!, $defaultValue: String, $fieldType: String!, $availableOptions: [String!], $autoAddCustomValues: Boolean, $restrictToAvailableOptions: Boolean, $enableBarcodeScanner: Boolean, $multipleValues: Boolean, $projectId: ID) {
    customFieldTemplateCreate(defaultLabel: $defaultLabel, defaultValue: $defaultValue, fieldType: $fieldType, availableOptions: $availableOptions, autoAddCustomValues: $autoAddCustomValues, restrictToAvailableOptions: $restrictToAvailableOptions, enableBarcodeScanner: $enableBarcodeScanner, multipleValues: $multipleValues, projectId: $projectId) {
      customFieldTemplate {
        ${fragment.CUSTOM_FIELD_TEMPLATE_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CUSTOM_FIELD_TEMPLATE_UPDATE = gql`
  mutation CustomFieldTemplateUpdate($id: ID!, $defaultLabel: String, $defaultValue: String, $fieldType: String, $availableOptions: [String!], $autoAddCustomValues: Boolean, $restrictToAvailableOptions: Boolean, $enableBarcodeScanner: Boolean, $multipleValues: Boolean) {
    customFieldTemplateUpdate(id: $id, defaultLabel: $defaultLabel, defaultValue: $defaultValue, fieldType: $fieldType, availableOptions: $availableOptions, autoAddCustomValues: $autoAddCustomValues, restrictToAvailableOptions: $restrictToAvailableOptions, enableBarcodeScanner: $enableBarcodeScanner, multipleValues: $multipleValues) {
      customFieldTemplate {
        ${fragment.CUSTOM_FIELD_TEMPLATE_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CUSTOM_FIELD_TEMPLATE_DESTROY = gql`
  mutation CustomFieldTemplateDestroy($id: ID!) {
    customFieldTemplateDestroy(id: $id) {
      customFieldTemplate {
        ${fragment.CUSTOM_FIELD_TEMPLATE_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CUSTOM_ASSET_FIELD_CREATE_MUTATION = gql`
  mutation CustomAssetFieldCreate(
    $customFieldTemplateId: ID!
    $assetId: ID!
    $label: String
    $value: String
    $order: Int
  ) {
    customAssetFieldCreate(
      customFieldTemplateId: $customFieldTemplateId
      assetId: $assetId
      label: $label
      value: $value
      order: $order
    ) {
      customAssetField {
        ${fragment.CUSTOM_FIELD_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CUSTOM_ASSET_FIELD_UPDATE_MUTATION = gql`
  mutation CustomAssetFieldUpdate($id: ID!, $label: String, $value: String, $order: Int) {
    customAssetFieldUpdate(id: $id, label: $label, value: $value, order: $order) {
      customAssetField {
        ${fragment.CUSTOM_FIELD_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const CREATE_SHARED_CLIENT_PROJECT_MUTATION = gql`
  mutation ShareClientProject($clientId: ID!, $projectId: ID!) {
    shareClientProject(clientId: $clientId, projectId: $projectId) {
      project {
        ${fragment.PROJECT_FRAGMENT}
      }
      client {
        ${fragment.CLIENT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const REMOVE_SHARED_CLIENT_PROJECT_MUTATION = gql`
  mutation RemoveSharedClientProject($projectId: ID!, $clientId: ID!) {
    removeSharedClientProject(projectId: $projectId, clientId: $clientId) {
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const MOBILE_WAREHOUSE_LOCATION_TRANSFER = gql`
  mutation MobileWarehouseLocationTransfer(
    $id: ID!
    $oldWarehouseLocationId: ID
    $newWarehouseLocationId: ID!
  ) {
    mobileWarehouseLocationTransfer(
      id: $id
      oldWarehouseLocationId: $oldWarehouseLocationId
      newWarehouseLocationId: $newWarehouseLocationId
    ) {
      success
      errors {
        message
      }
      mobileWarehouseLocation {
        id
        locationName
        locationId
        warehouse {
          id
          name
          warehouseId
        }
        warehouseLocations {
          id
          locationName
          warehouse {
            id
            name
            warehouseId
          }
        }
      }
    }
  }
`;

export const CREATE_SCHEDULER_MUTATION = gql`
  mutation CreateScheduler($name: String, $frequency: String!, $daysOfWeek: [String!], $dayOfMonth: String, $dateRangeMode: String, $notes: String, $projectsReports: [ProjectReportSchedulerInput!]) {
    createScheduler(name: $name, frequency: $frequency, daysOfWeek: $daysOfWeek, dayOfMonth: $dayOfMonth, dateRangeMode: $dateRangeMode, notes: $notes, projectsReports: $projectsReports) {
      scheduler {
        id
        name
        frequency
        active
        nextRunAt
        lastRunAt
        daysOfWeek
        dayOfMonth
        dateRangeMode
        notes
        reportsSchedulers {
          id
          project {
            id
            name
          }
          favoriteReport {
            id
            payload
          }
          options
        }
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_SCHEDULER_MUTATION = gql`
  mutation UpdateScheduler($id: ID!, $name: String, $active: Boolean, $frequency: String, $daysOfWeek: [String!], $dayOfMonth: String, $dateRangeMode: String, $notes: String, $addReports: [ProjectReportSchedulerInput!], $removeReports: [ProjectReportSchedulerInput!]) {
    updateScheduler(id: $id, name: $name, active: $active, frequency: $frequency, daysOfWeek: $daysOfWeek, dayOfMonth: $dayOfMonth, dateRangeMode: $dateRangeMode, notes: $notes, addReports: $addReports, removeReports: $removeReports) {
      scheduler {
        id
        name
        frequency
        active
        nextRunAt
        lastRunAt
        daysOfWeek
        dayOfMonth
        dateRangeMode
        notes
        reportsSchedulers {
          id
          project {
            id
            name
          }
          favoriteReport {
            id
            payload
          }
          options
        }
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const DELETE_SCHEDULER_MUTATION = gql`
  mutation DeleteScheduler($id: ID!) {
    deleteScheduler(id: $id) {
      success
    }
  }
`;

export const ASSETS_BULK_TRANSFER_MUTATION = gql`
  mutation AssetsBulkTransfer($projectId: ID!, $assetIds: [ID!]!) {
    assetsBulkTransfer(projectId: $projectId, assetIds: $assetIds) {
      assets {
        ${fragment.ASSET_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const COPY_AND_DISABLE_ASSET_REPLAY_LOG_MUTATION = gql`
  mutation CopyAndDisableAssetReplayLog($id: ID!, $rackLocations: JSON!) {
    copyAndDisableAssetReplayLog(id: $id, rackLocations: $rackLocations) {
      assetReplayLog {
        id
        assetId
        performedAt
        rackLocations
        disabledForBilling
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ADD_PALLET_TYPE_MUTATION = gql`
  mutation AddPalletType($companyId: ID, $projectId: ID, $name: String!, $description: String) {
    addPalletType(
      companyId: $companyId
      projectId: $projectId
      name: $name
      description: $description
    ) {
      palletType {
        id
        name
        description
        isActive
        sortOrder
      }
      errors {
        field
        message
      }
    }
  }
`;

export const UPDATE_PALLET_TYPE_MUTATION = gql`
  mutation UpdatePalletType(
    $companyId: ID
    $projectId: ID
    $palletTypeId: String!
    $description: String
    $isActive: Boolean
    $sortOrder: Int
  ) {
    updatePalletType(
      companyId: $companyId
      projectId: $projectId
      palletTypeId: $palletTypeId
      description: $description
      isActive: $isActive
      sortOrder: $sortOrder
    ) {
      palletType {
        id
        name
        description
        isActive
        sortOrder
      }
      errors {
        field
        message
      }
    }
  }
`;

export const ADD_UNIT_TYPE_MUTATION = gql`
  mutation AddUnitType($companyId: ID, $projectId: ID, $name: String!, $description: String) {
    addUnitType(
      companyId: $companyId
      projectId: $projectId
      name: $name
      description: $description
    ) {
      unitType {
        id
        name
        description
        isActive
        sortOrder
      }
      errors {
        field
        message
      }
    }
  }
`;

export const UPDATE_UNIT_TYPE_MUTATION = gql`
  mutation UpdateUnitType(
    $companyId: ID
    $projectId: ID
    $unitTypeId: String!
    $description: String
    $isActive: Boolean
    $sortOrder: Int
  ) {
    updateUnitType(
      companyId: $companyId
      projectId: $projectId
      unitTypeId: $unitTypeId
      description: $description
      isActive: $isActive
      sortOrder: $sortOrder
    ) {
      unitType {
        id
        name
        description
        isActive
        sortOrder
      }
      errors {
        field
        message
      }
    }
  }
`;

export const ADD_SQUARE_FOOTAGE_TYPE_MUTATION = gql`
  mutation AddSquareFootageType($companyId: ID, $projectId: ID, $name: String!, $description: String) {
    addSquareFootageType(
      companyId: $companyId
      projectId: $projectId
      name: $name
      description: $description
    ) {
      squareFootageType {
        id
        name
        description
        isActive
        sortOrder
      }
      errors {
        field
        message
      }
    }
  }
`;

export const UPDATE_SQUARE_FOOTAGE_TYPE_MUTATION = gql`
  mutation UpdateSquareFootageType(
    $companyId: ID
    $projectId: ID
    $squareFootageTypeId: String!
    $description: String
    $isActive: Boolean
    $sortOrder: Int
  ) {
    updateSquareFootageType(
      companyId: $companyId
      projectId: $projectId
      squareFootageTypeId: $squareFootageTypeId
      description: $description
      isActive: $isActive
      sortOrder: $sortOrder
    ) {
      squareFootageType {
        id
        name
        description
        isActive
        sortOrder
      }
      errors {
        field
        message
      }
    }
  }
`;

export const CREATE_DELIVERY_MUTATION = gql`
  mutation CreateDelivery($inventoryRequestId: ID!) {
    createDelivery(inventoryRequestId: $inventoryRequestId) {
      delivery {
        ${fragment.DELIVERY_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_DELIVERY_MUTATION = gql`
  mutation UpdateDelivery($id: ID!, $inventoryRequestId: ID, $workOrderNumber: String, $poNumber: String, $comment: String, $deliveryNotes: String, $location: String, $deliveryDate: String, $contactName: String, $contactPhoneNumber: String, $email: String, $deliveryUserId: ID, $receiverUserId: ID, $vaStatus: JSON, $locationNotes: JSON, $street: String, $city: String, $zip: String) {
    updateDelivery(id: $id, inventoryRequestId: $inventoryRequestId, workOrderNumber: $workOrderNumber, poNumber: $poNumber, comment: $comment, deliveryNotes: $deliveryNotes, location: $location, deliveryDate: $deliveryDate, contactName: $contactName, contactPhoneNumber: $contactPhoneNumber, email: $email, deliveryUserId: $deliveryUserId, receiverUserId: $receiverUserId, vaStatus: $vaStatus, locationNotes: $locationNotes, street: $street, city: $city, zip: $zip) {
      delivery {
        ${fragment.DELIVERY_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_DELIVERY_ITEM_MUTATION = gql`
  mutation UpdateDeliveryItem($id: ID!, $quantity: Int, $comment: String, $poNumber: String, $location: String, $building: String, $floor: String, $room: String, $pickedStatus: Boolean, $status: String, $street: String, $city: String, $zip: String, $verifiedDeliveredQuantity: Int) {
    updateDeliveryItem(id: $id, quantity: $quantity, comment: $comment, poNumber: $poNumber, location: $location, building: $building, floor: $floor, room: $room, pickedStatus: $pickedStatus, status: $status, street: $street, city: $city, zip: $zip, verifiedDeliveredQuantity: $verifiedDeliveredQuantity) {
      deliveryItem {
        ${fragment.DELIVERY_ITEM_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const ADD_DELIVERY_ATTACHMENT_MUTATION = gql`
  mutation DeliveryAddAttachment($file: Upload!, $deliveryId: ID!) {
    deliveryAddAttachment(file: $file, deliveryId: $deliveryId) {
      attachment {
        ${fragment.ATTACHMENT_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const REMOVE_DELIVERY_ATTACHMENT_MUTATION = gql`
  mutation DeliveryRemoveAttachment($deliveryId: ID!, $id: ID!) {
    deliveryRemoveAttachment(deliveryId: $deliveryId, id: $id) {
      success
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const LINK_EXTERNAL_RECORD_MUTATION = gql`
  mutation LinkExternalRecord($projectId: ID!, $externalRecordId: ID!) {
    linkExternalRecord(projectId: $projectId, externalRecordId: $externalRecordId) {
      project {
        id
        orderNumber
        customerPoNumber
        customerNotes
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UNLINK_EXTERNAL_RECORD_MUTATION = gql`
  mutation UnlinkExternalRecord($projectId: ID!) {
    unlinkExternalRecord(projectId: $projectId) {
      project {
        id
        orderNumber
        customerPoNumber
        customerNotes
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

const LINKABLE_EXTERNAL_RECORD_FIELDS = `
  id
  recordType
  externalId
  displayName
  data
`;

export const LOOKUP_EXTERNAL_RECORD_MUTATION = gql`
  mutation LookupExternalRecord($linkableType: String!, $linkableId: ID!, $externalId: ID!) {
    lookupExternalRecord(linkableType: $linkableType, linkableId: $linkableId, externalId: $externalId) {
      externalRecord {
        ${LINKABLE_EXTERNAL_RECORD_FIELDS}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const LINK_LINKABLE_EXTERNAL_RECORD_MUTATION = gql`
  mutation LinkLinkableExternalRecord($linkableType: String!, $linkableId: ID!, $externalRecordId: ID!) {
    linkExternalRecord(linkableType: $linkableType, linkableId: $linkableId, externalRecordId: $externalRecordId) {
      shipment {
        id
        externalRecords {
          ${LINKABLE_EXTERNAL_RECORD_FIELDS}
        }
      }
      inventoryRequest {
        id
        externalRecords {
          ${LINKABLE_EXTERNAL_RECORD_FIELDS}
        }
      }
      internalWorkOrder {
        id
        externalRecords {
          ${LINKABLE_EXTERNAL_RECORD_FIELDS}
        }
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UNLINK_LINKABLE_EXTERNAL_RECORD_MUTATION = gql`
  mutation UnlinkLinkableExternalRecord($linkableType: String!, $linkableId: ID!) {
    unlinkExternalRecord(linkableType: $linkableType, linkableId: $linkableId) {
      shipment {
        id
        externalRecords {
          ${LINKABLE_EXTERNAL_RECORD_FIELDS}
        }
      }
      inventoryRequest {
        id
        externalRecords {
          ${LINKABLE_EXTERNAL_RECORD_FIELDS}
        }
      }
      internalWorkOrder {
        id
        externalRecords {
          ${LINKABLE_EXTERNAL_RECORD_FIELDS}
        }
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_COMPANY_CONFIGURATION_SETTING_MUTATION = gql`
  mutation UpdateCompanyConfigurationSetting($key: String!, $value: JSON!) {
    updateCompanyConfigurationSetting(key: $key, value: $value) {
      company {
        id
        settings
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const UPDATE_COMPANY_ADMINISTRATION_SETTINGS_MUTATION = gql`
  mutation UpdateCompanyAdministrationSettings(
    $emailsSendList: String
    $holidayCountry: String
    $enabledBillingTypes: [String!]
    $taxableChargeTypes: [String!]
    $storageCalculationMethod: String
    $useMobileLocationForPalletColocation: Boolean
    $labelsLogoUrl: Upload
    $removeLabelsLogoUrl: Boolean
    $secondaryLogoUrl: Upload
    $removeSecondaryLogoUrl: Boolean
    $subsidiaryLogoUrl: Upload
    $removeSubsidiaryLogoUrl: Boolean
    $subsidiary2LogoUrl: Upload
    $removeSubsidiary2LogoUrl: Boolean
  ) {
    updateCompanyAdministrationSettings(
      emailsSendList: $emailsSendList
      holidayCountry: $holidayCountry
      enabledBillingTypes: $enabledBillingTypes
      taxableChargeTypes: $taxableChargeTypes
      storageCalculationMethod: $storageCalculationMethod
      useMobileLocationForPalletColocation: $useMobileLocationForPalletColocation
      labelsLogoUrl: $labelsLogoUrl
      removeLabelsLogoUrl: $removeLabelsLogoUrl
      secondaryLogoUrl: $secondaryLogoUrl
      removeSecondaryLogoUrl: $removeSecondaryLogoUrl
      subsidiaryLogoUrl: $subsidiaryLogoUrl
      removeSubsidiaryLogoUrl: $removeSubsidiaryLogoUrl
      subsidiary2LogoUrl: $subsidiary2LogoUrl
      removeSubsidiary2LogoUrl: $removeSubsidiary2LogoUrl
    ) {
      company {
        id
        settings
        emailsSendList
        labelsLogoUrl
        secondaryLogoUrl
        subsidiaryLogoUrl
        subsidiary2LogoUrl
        blackoutDates
        enabledBillingTypes
        taxableChargeTypes
        storageCalculationMethod
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;

export const SIGN_DELIVERY_MUTATION = gql`
  mutation SignDelivery($deliveryId: ID!, $signerName: String!, $signatureImage: Upload!) {
    signDelivery(deliveryId: $deliveryId, signerName: $signerName, signatureImage: $signatureImage) {
      delivery {
        ${fragment.DELIVERY_FRAGMENT}
      }
      errors {
        ${fragment.ERROR_FRAGMENT}
      }
    }
  }
`;
